import { animate, scroll } from 'motion';

export default function init() {
  const parallaxElement = document.querySelector('[data-el="parallax"]');
  scroll(animate(parallaxElement, { y: [0, 500] }));
}
